module.exports = __webpack_public_path__ + "img/click_tab5.50a6cd08.png";